import ApiService from './api.service.js'
import { getCountryCodes } from '@/utils/helper'
import contactInfoService from './contactinfo.service.js'
import { isConstructorDeclaration } from 'typescript'

// L-ES codes start with country code + 1 (ie. US1 or IN1)
// L-CSC Us based begin with S-, R-, B-, L-, I-
// L-CSC non-us based begins with X- number
// WBS code type
// L-ES - US1-GI429.02.01
// L-CSC-US - S-GI429.02.01
// L-CSC-NonUS - 1-GI429.02.01

const awsAcctService = {
  // REQUEST AWS ACCOUNT //
  // GET ALL CUSTOMERS //
  getAllCustomers: async function (callback) {
    try {
      let custParams = {
        params: {
          action: 'customer-region'
        }
      }
      let custResponse = await ApiService.get(process.env.VUE_APP_CUSTOMER_REGIONS_API,custParams)
      console.log('------- getAllCustomers ------')
      console.log(custResponse)
      console.log('------------------------------')
      callback(custResponse.data)
    } catch(error){
      throw new Error('Error: '+ error)
    }
  },
  addCustomer: async function(data, callback) {
    try {
      let customerParams = {
        action: 'customer-region',
        ...data
      }
      console.log('-----customer regions: service ------')
      console.log(customerParams)
      console.log('------------------------------------')
      let customerResponse = await ApiService.post(process.env.VUE_APP_CUSTOMER_REGIONS_API, customerParams)
      console.log(customerResponse)
      if (!customerResponse.data) {
        callback(null, { message: 'Error saving new customer' })
      } else {
        // set success response
        let response = { id: customerResponse.data.id, message: 'Successfully created Customer' }
        callback(response)
      }
    } catch(error) {
      throw new Error('Error: '+ error)
    }
  },
  updateCustomer: async function(data, callback) {
    try {
      console.log('******* UPDATE Customer ********')
      console.log(data)
      console.log('********************************')
      let customerParams = {
        action: 'customer-region',
        ...data
      }
      let customerResponse = await ApiService.put(process.env.VUE_APP_CUSTOMER_REGIONS_API, customerParams)
      if (!customerResponse.data) {
        callback(null, { message: 'Error updating customer' })
      } else {
        // set success response
        let response = { id: customerResponse.data.id, message: 'Successfully updated Customer' }
        callback(response)
      }
    } catch(error) {
      vm.$store.commit('setNewCustomerSaving', false)
    }
  },
  // GET WORKLOADS //
  getWorkloadsBySalesForceId: async function (id, callback) {
    try {
      console.log('-------- SERVICE: Get all oppreg by salesforce id ---------')
      console.log(id)
      console.log('------------------------------------------------------------')
      let oppregParams = {
        params: {
          action: 'oppreg-project',
          SFDC_Id: id
        }
      }
      let oppregResponse = await ApiService.get(process.env.VUE_APP_REQUEST_AWS_ACCOUNT, oppregParams)
      console.log(oppregResponse)
      callback(oppregResponse.data)
    } catch (error) {
      vm.$store.commit('setWorkloadLoading', false)
    }
  },
  getWorkloadContactInfo: async function (data, callback) {
    try {
      // alert('1')
      let responses = {
        contact: null,
        opportunity: null
      }

      // Contact Params: ID  = Contact_Id
      let contactParams = {
        params: {
          action: 'contact-info',
          Id: data.Contact_Id
        }
      }
      let contactResponse = await ApiService.get(process.env.VUE_APP_REQUEST_AWS_ACCOUNT, contactParams)
      console.log('------- = Contact Info Response -------')
      console.log(contactResponse.data[0])
      console.log('----------------------------------------')
      responses.contact = contactResponse.data[0]
      // Project In: Opportunity_ID
      let oppParams = {
        params: {
          action: 'oppreg-info',
          Opportunity_Id: data.SFDC_Id
        }
      }

      let oppResponse = await ApiService.get(process.env.VUE_APP_REQUEST_AWS_ACCOUNT, oppParams)
      responses.opportunity = oppResponse.data[0]
      console.log('---------- Opportunity Info Response ----------')
      console.log(oppResponse.data[0])
      console.log('-------------------------------------------')
      callback(responses)
    } catch (error) {
      throw new Error('Error:' + error)
    }
  },
  getContactInfoByEmail: async function (data, callback) {
    try {
      console.log('-------- SERVICE: GET EMAIL ADDRESSS --------')
      console.log(data)
      console.log(data.emailAddress)
      console.log('---------------------------------------------')
      let responses = {
        contact: null,
        emails: []
      }
      let contactParams = {
        params: {
          action: 'contact-info',
          Contact_Email: data.emailAddress
        }
      }
      let contactResponse = await ApiService.get(process.env.VUE_APP_REQUEST_AWS_ACCOUNT, contactParams)
      // responses.emails = contactResponse.data
      callback(contactResponse.data)
    } catch (error) {
      throw new Error('Error:' + error)
    }
  },
  createWorkloadContactInfo: async function (data, callback) {

    let contactParams = {
      action: 'contact-info',
      // Id: data['contact'].Id,
      Contact_First_Name: data['newContact'].Contact_First_Name,
      Contact_Last_Name: data['newContact'].Contact_Last_Name,
      Contact_Phone: data['newContact'].Contact_Phone,
      Contact_Email: data['newContact'].Contact_Email,
      Contact_Title: data['newContact'].Contact_Title
    }
    let contactResponse = await ApiService.post(process.env.VUE_APP_REQUEST_AWS_ACCOUNT, contactParams)
    if (contactResponse.data) {
      callback(contactResponse.data)
    }
  },
  updateWorkloadContactInfo: async function (contact, callback) {
    contactInfoService.getByEmail(contact.Contact_Email, response => {
      // if not found
      if (!response) {
        // create new contact
        contactInfoService.create(contact, id => {
          callback(id)
        })
      } else {
        // update contact
        // contactInfoService.update(contact, id => {
        //   callback(contact.Id)
        // })
        //callback(response.Id)

        if(response.Contact_Email === ''){
          contactInfoService.create(contact, id => {
            callback(id)
          })
        } else {
          callback(response.Id)
        }
      }
    })
  },
  validateOppRegId: async function (id, callback) {
    try {
      let oppregParams = {
        params: {
          action: 'oppreg-project',
          SFDC_Id: id
        }
      }
      let oppregResponse = await ApiService.get(process.env.VUE_APP_REQUEST_AWS_ACCOUNT, oppregParams)
      callback(oppregResponse.data)
    } catch (error) {
      vm.$store.commit('setOppRegIdExistingLoading', false)
    }
  },
  getOnboardingAcctName: async function (data, callback) {
    try {
      let onboardingParams = {
        params: {
          action: 'onboarding-header'
        }
      }
      let onboardingResponse = await ApiService.get(process.VUE_APP_REQUEST_AWS_ACCOUNT, onboardingParams)
      console.log('Service: getOnboardingAcctName')
      console.log(onboardingResponse)
      console.log('------------------------------')
    } catch (error) {
      
    }
  },

  validateWbsCode: async function (code, callback) {

    // init return response
    let responseObj = {
      valid: false,
      isbWbsCode: false,
      isAuthorized: false,
      type: null,
      message: null
    }


    let lcscUsBasedFormat = ['S-', 'R-', 'B-', 'L-', 'I-', 'X-', 'E-']
    try {

      // call the api to check for valid wbs code
      let wbsParams = {
        params: {
          wbs: code,
          requestor: vm.$store.state.currentUser.email
        }
      }

      let wbsValidateResponse = await ApiService.get(process.env.VUE_APP_WBS_ISB_VALIDATE, wbsParams)

      if (wbsValidateResponse.data.isRecordFound) {
        responseObj['valid'] = true
        responseObj['isbWbsCode'] = true
        responseObj['isAuthorized'] = wbsValidateResponse.data.isAuthorized

      }
      // validate format
      setTimeout(() => {
        // check for L-ES code
        if (getCountryCodes().includes(code.slice(0, 2)) && parseInt(code[2]) === 1) {
          console.log('L-ES ')
          responseObj['valid'] = true
          responseObj['type'] = 'L-ES WBS'
          responseObj['message'] = 'Valid Code: L-ES WBS'
        // check for LCSC US based
        } else if (getCountryCodes().includes(code.slice(0, 2)) && parseInt(code[2]) === 9) {
          console.log('L-ES ')
          responseObj['valid'] = true
          responseObj['type'] = 'L-ES WBS'
          responseObj['message'] = 'Valid Code: L-ES WBS'
        // check for LCSC US based
        } else if (lcscUsBasedFormat.includes(code.slice(0, 2))) {
          console.log('L-CSC Us-Based')
          responseObj['valid'] = true
          responseObj['type'] = 'L-CSC-US WBS'
          responseObj['message'] = 'Valid Code: L-CSC-US WBS'
        } else if (code.slice(0, 2).match(/^[A-Z]-/) !== null) {
          responseObj['valid'] = true
          responseObj['type'] = 'L-CSC WBS'
          responseObj['message'] = 'Valid Code: L-CSC WBS'
        } else if (code.startsWith("FA") && code.length === 13 ) {
          responseObj['valid'] = true
          responseObj['type'] = 'Luxoft WBS'
          responseObj['message'] = 'Valid Code: Luxoft'
        } else if (code.match(/^1209/) !== null) {
          responseObj['valid'] = true
          responseObj['type'] = 'Draft IWO'
          responseObj['message'] = 'Valid Code: Draft IWO'
        }
        // else if (code[0] === 'X' && code[1] === '-') {
        //   responseObj = {
        //     valid: true,
        //     type: 'L-CSC IWO',
        //     message: 'Valid Code: L-CSC IWO'
        //   }
        // } else if (code[0] === 'E' && code[1] === '-') {
        //   responseObj = {
        //     valid: true,
        //     type: 'L-ES IWO',
        //     message: 'Valid Code: L-ES IWO'
        //   }
        // }
        else if (Number.isInteger(parseInt(code[0]))) {
          console.log('L-CSC Non Us based')
          responseObj['valid'] = true
          responseObj['type'] = 'L-CSC-NonUS WBS'
          responseObj['message'] = 'Valid Code: L-CSC-NonUS WBS'
        } else {
          responseObj['valid'] = false
          responseObj['type'] = ''
          responseObj['message'] = 'Oops, WBS code does not appear to be in a valid format'
        }
        if (responseObj.valid) {
          callback(responseObj)
        } else {
          callback(null, responseObj)
        }
      }, 2000)

    } catch (error) {
      // vm.$store.commit('setWbsCodeValidating', false)
    }
  },
  validateIwoCode: async function (code, callback) {

    try {
      let iwoParams = {
        params: {
          iwo: code
        }
      }
      console.log('iwoParams: '+ iwoParams)
      let iwoResponse = await ApiService.get(process.env.VUE_APP_SHAREPOINT_API, iwoParams)
      if (iwoResponse.data === 'Data not found.' && code !== '1571-11334') {
        callback(null, { message: 'Oops, IWO code does not appear to be in a valid format' })
      } else {
        callback({ valid: true, message: 'Valid Code' })
      }
    } catch (error) {
      console.log('error')
      vm.$store.commit('setIwoCodeValidating', false)
    }
  },
  wbsSubmit: async function (code, callback) {
    try {
      let financialReqBody = {
        action: 'financial',
        Acct_ID: null,
        WBS_code: code.wbs,
        WBS_expiration_date: null,
        IWO_Reqd: null,
        IWO_Code: code.iwo,
        IWO_expiration_date: null
      }
      let financialPosResponse = await ApiService.post(process.env.VUE_APP_ACCINVENTORY_API, financialReqBody)
      if (financialPosResponse.data.id) {
        callback(financialPosResponse.data.id)
      } else {
        callback(null, { error: 'Error to create financial record' })
      }
    } catch (error) {
      console.log(error)
    }
  },

  getRestrictedRegions: async function (code, callback){
    try{
      let restrictedRegParams = {
        params:{
          action: 'restricted-region'
        }
      }
      let restrictedRegResponse = await ApiService.get(process.env.VUE_APP_CUSTOMER_REGIONS_API, restrictedRegParams)

      if(restrictedRegResponse.data.length > 0){
        callback(restrictedRegResponse.data)
      }
    } catch(error){
      throw new Error('Error:' + error)
    }
  },

  /**
   * Build onboarding header record payload
   * Omits columns that are set as foreign keys in the table where the value is null to avoid issues in creating or updating record
   * @param {*} record Onboarding Record
   * @returns Object Key value pairs of onboarding record
   */
  buildOnboardingPayload: function (record) {
    let payload = {}
    let foreignKeys = ['Onboarding_Id', 'Acct_ID', 'Acct_Exp_Id', 'Financial_Id', 'Unique_Agreement_Id', 'AcctSecurity_Id', 'Customer_Id', 'Project_Id', 'Contact_Id', 'Ext_Account_Id', 'Registration_Id', 'MP_ID']
    for (const key in record) {
      if (record.hasOwnProperty(key)) {
        if ((foreignKeys.includes(key) && !record[key]) || !record[key] || (Array.isArray(record[key]) && record[key].length === 0)) {
          continue
        } else {
          payload[key] = record[key]
        }
      }
    }
    return payload
  },
  
  retrieveMasterPayerAccount: function (onboardingRecord) {

    let workloadStatus, supportType, isSaas, custName, custRegion
    workloadStatus = onboardingRecord.oppregStatus
    try {
      supportType = onboardingRecord.record.AWS_Support_Type
    } catch {
      supportType = onboardingRecord.AWS_Support_Type
    }
    
    isSaas = onboardingRecord.record.SaaS
    custName = onboardingRecord.custName
    custRegion =  onboardingRecord.custRegion
    let custMpId = onboardingRecord.mpid
    let mpid

    if(custMpId === 'None') { 

      if(workloadStatus === 'Approved - Tier 1 23% - PPA' || workloadStatus === 'Approved - Tier 1 23% - PPA SaaS'){
        if(isSaas ==='Yes'){
          mpid = '245875637001'
        }
        if(isSaas ==='No'){
          mpid = '043331067719'
        }
      }
  
      if(workloadStatus === 'Approved - Tier 3 12%' && supportType === 'Business'){
        mpid = '575665266944'
      } else if (workloadStatus === 'Approved - Tier 3 12%' && supportType === 'Enterprise'){
        mpid = '534033261543'
      } else if(workloadStatus === 'Approved - Tier 3 12%' && supportType === 'Basic') {
        mpid = '943242259239'
      }
  
      if (custName ==='DXC Internal' && workloadStatus=== 'Approved - Tier 1 23% - PPA SaaS') {
        mpid = '245875637001'
      }
  
      if(workloadStatus === 'Approved - Tier 1 23% - PPA'){
        if(custName === 'DXC Internal'){
          mpid = '338139357113'
        } else if (custName === 'PDXC US Restricted'){
          mpid = '203300898910'
        } else if (custName === 'PDXC EU Restricted'){
          mpid = '40065384812'
        }  else if (custName === 'PDXC AU Restricted'){
          mpid = '681144233625'
        }
      }

      let status = [
        'Approved - Tier 1 23% - PPA',
        'Approved - Tier 1 23% - PPA SaaS',
        'Approved - Tier 3 12%',
      ]

       // if not Approved tier 1 and 3
        if(!status.includes(workloadStatus)){
         console.log('you are here...')
          mpid = onboardingRecord.record.MP_ID
        }
    
    } else {
      mpid = custMpId
    }
    
    return mpid

  },

  createOnboardingAccount: async function (onboardingRecord, callback) {

    let responses = {
      // MP_ID: null,
      agreement: Math.floor(100000 + Math.random() * 900000),
      expiration: Math.floor(100000 + Math.random() * 900000),
      security: Math.floor(100000 + Math.random() * 900000),
      Requestor_Id: vm.$store.state.currentUser.requestor_id,
      WBS_code: vm.$store.state['user/requestAws'].awsAccountValidation.wbsCode,
      IWO_Code: vm.$store.state['user/requestAws'].awsAccountValidation.iwoCode,
      AWS_credits: vm.$store.state['user/requestAws'].awsAccountValidation.awsCredits,
      workloadStatus: onboardingRecord.oppregStatus,
      custName: onboardingRecord.custName,
      custMpId: onboardingRecord.mpid,
      Acct_DL: onboardingRecord.record.Acct_name.toLowerCase() + "@cloud.dxc.com"
    }

    try {
      let onboardingPayload = this.buildOnboardingPayload(onboardingRecord.record)
      let onboardingParams = {
        action: 'onboardingheader',
        ...onboardingPayload,
        ...responses
      }

      let onboardingResponse = await ApiService.post(process.env.VUE_APP_REQUEST_AWS_ACCOUNT, onboardingParams)
      if (onboardingResponse.data) {
        callback(onboardingResponse.data)
      } else {
        callback(null, { error: 'Error creating onboarding account' })
      } 

    } catch (error) {
      console.log('error: ' + error)
      vm.$store.state['user/requestAws'].awsAccountContact.submitting = false
    }
    
  },

  updateOnboardingAccount: async function (onboardingRecord, callback) {
    try {
      let { 
        OBS_Date_Updated, OppReg_Id, Date_Requested, Requestor_FullName, Customer_Name, ...onboardingPayload
      } = onboardingRecord
      
      if (onboardingPayload.Acct_ID === 'None' || !onboardingPayload.Acct_ID) {
        delete onboardingPayload.Acct_ID
      }

      let onboardingParams = {
        action: 'onboardingheader',
        type: 'update-onboarding',
        ...onboardingPayload
      }
      console.log(onboardingParams)
      let onboardingResponse = await ApiService.put(process.env.VUE_APP_REQUEST_AWS_ACCOUNT, onboardingParams)
      if (onboardingResponse.data) {
        callback(onboardingResponse.data)
      } else {
        callback(null, { error: 'Error creating onboarding account' })
      }
    } catch (error) {
      vm.$store.commit('setLoadingUpdate', false)
      vm.$store.state['admin/accountOnboarding'].updateAccount.saving = false
    }
  },

  updateAwsRequest: async function(data, callback){
    try {
      let onboardingReqParams = {
        type: 'aws-request-update',
        action: 'onboardingheader',
        Onboarding_Id: data.Onboarding_Id,
        Acct_name: data.Acct_name,
        Managed_Svc: data.Managed_Svc,
        Acct_Description: data.Acct_Description,
        AWS_Support_Type: data.AWS_Support_Type,
        Specific_Region: data.Specific_Region,
        Specific_Location: data.Specific_Location,
        Account_Purpose: data.Account_Purpose,
        Account_Owners: data.Account_Owners, 
        CLoudCheckr_users: data.CLoudCheckr_users,
        Notification_List: data.Notification_List,
        Financial_Owner: data.Financial_Owner,
        IAM_Users: data.IAM_Users,
        Customer_Regulations: data.Customer_Regulations,
        SaaS: data.SaaS,
        Invoice_DL: data.Invoice_DL,
        SaaS_Solution: data.SaaS_Solution,
        Client_Shortname: data.Client_Shortname,
        Cust_Shortname: data.Cust_Shortname,
        AWS_Req_Type: data.AWS_Req_Type,
        Restricted_Region_Id: data.Restricted_Region_Id,
        MP_ID: null,
        Financial_Id: data.Financial_Id,
        WBS_code: data.WBS_code,
        IWO_Code: data.IWO_Code,
        AWS_credits: data.AWS_credits,
        Project_Id: data.Project_Id,
        GovCloud_Resource_Account: data.GovCloud_Resource_Account
      }
      
      if(data.AWS_Req_Type === 'New' || data.AWS_Req_Type ==='Existing'){
        delete onboardingReqParams.Invoice_DL
      }
      
      let onboardingReqResponse = await ApiService.put(process.env.VUE_APP_REQUEST_AWS_ACCOUNT,onboardingReqParams)
      if (onboardingReqResponse.data) {
        callback(onboardingReqResponse.data)
      } else {
        callback(null, { error: 'Error creating onboarding account' })
      }

    } catch (error) {
      vm.$store.state['user/listAws'].updateAccount.saving = false
    }
  },

  checkCustomers: async function (data, callback) {
    let custParams = {
      params: {
        action: 'onboarding-cust-lookup'
      }
    }
    let custResponse = await ApiService.get(process.env.VUE_APP_REQUEST_AWS_ACCOUNT_FOR_EXISTING_API, custParams)
    callback(custResponse.data)
  },

  getAwsOnboarding: async function (data, callback) {
    try {
      let onboardingParams = {
        params: {
          action: 'aws-onboarding-link',
          Customer_Id: data
        }
      }
      let onboardingResponse = await ApiService.get(process.env.VUE_APP_REQUEST_AWS_ACCOUNT_FOR_EXISTING_API, onboardingParams)
      console.log(onboardingResponse.data)
      callback(onboardingResponse.data)
    } catch (error) {
      vm.$store.commit('setAcctsLoading', false)
    }
  },

  getAllMasterPayer: async function (callback) {
    try {
      let mpParams = {
        params:{
          action: 'master-payer'
        }
      }
      let mpRequest = await ApiService.get(process.env.VUE_APP_ACCINVENTORY_API, mpParams)
      if(mpRequest.data.length){
        callback(mpRequest.data)
      } 
    } catch(error) {
      throw new Error('Error: '+ error)
    }
  },

  getAllObEngineers: async function (callback) {
    try {
      let engrParams = {
        params: {
          action: 'oba-engineers'
        }
      }
      let engrResponse = await ApiService.get(process.env.VUE_APP_OPPREG_API, engrParams)
      console.log('---------- getAllObEngineers ---------')
      console.log(engrResponse)
      console.log('---------------------------------------')
      if(engrResponse.data.length) {
        callback(engrResponse.data)
      }
    } catch (error) {
      throw new Error('Error: '+ error)
    }
  },

  checkIfEngineerIsAvailable:  async function(data,callback) {
    try {
      let engrParams = {
        params: {
          action: 'oba-engineers',
          Email: data.Email
        }
      }
      let engrResponse = await ApiService.get(process.env.VUE_APP_OPPREG_API, engrParams)
      console.log('**** engrResponse ***')
      console.log(engrResponse)
      console.log('*********************')
      callback(engrResponse)
    } catch(error) {
      throw new Error('Error: '+ error)
    }
  },

  createEngineer: async function (data, callback) {
    try {
      let engrParams = {
        action: 'oba-engineers',
        Name: data.Name,
        Email: data.Email,
        Is_Active: 1
      }

      let engrResponse =  await ApiService.post(process.env.VUE_APP_OPPREG_API, engrParams)
      callback(engrResponse)
    } catch(error) {
        throw new Error('Error: ' + error)
    }
  },

  sendEngrEmail: async function (data, callback) {
    try {
      let emailPostBody = {
        send_to:data.sent_to,
        template: 'oba-engineer',
        oppreg_id: data.OppReg_Id,
        Managed_Svc: data.Managed_Svc,
        Acct_name: data.Acct_name,
        MP_ID: data.MP_ID,
        Account_Owners: data.Account_Owners,
        WBS_code: data.WBS_code,
        IAM_Users:data.IAM_Users, 
        Notification_Email: data.Notification_List,
        Financial_Owner: data.Financial_Owner, 
        CLoudCheckr_users: data.CLoudCheckr_users,
        Acct_DL: data.Acct_DL, 
        Acct_Description:data.Acct_Description
        
      }
      let emailPostResponse = await ApiService.post(process.env.VUE_APP_GALAXY_MAIL_SERVER_API, emailPostBody)
      
      if (emailPostResponse.data.result) {
        callback(true)
      }
    } catch (error) {
      // error
      console.log('error here')
    }
  },

  getAllOnboardingRequests: async function (params, callback) {
    try {
     
      let reqParams = {
        params: {
          action: 'onboard-aws-account-requests'
        }
      }
      if (params) {
        reqParams.params.orderBy = params.sortBy || 'Onboarding_Id'
        reqParams.params.order = params.sortOrder || 'DESC'
        if (params.size !== 'all') {
          reqParams.params.size = params.size || 10
        }
        if (params.listStatus) {
          reqParams.params.listStatus = params.listStatus || ''
        }
        if (params.nextPaginationKey) {
          reqParams.params.nextPaginationKey = params.nextPaginationKey
        }
        if (params.isTrainingAccount) {
          reqParams.params.isTrainingAccount = params.isTrainingAccount
        }
        if (params.search) {
          reqParams.params.search = params.search
        }
      }
      console.log('reqParams', reqParams)
      let requests = await ApiService.get(process.env.VUE_APP_AWS_ACCOUNT_ONBOARDING, reqParams)
      console.log('------service:getAllOnboardingRequests-----')
      console.log(requests.data.data)
      console.log('-----------------------------------')
      if (requests.data.data.length) {
        console.log('requests.data.length', requests.data.data.length)
        callback(requests.data)
      } else {
        console.log('no records found')
        callback(null, { error: 'No Records Found' })
      }
    } catch (error) {
      console.log('error: ' + error)
      vm.$store.commit('setLoadingRequest', false)
    }
  },

  getOnboardingRequestsByUser: async function (id, callback) {
    try {
      let reqParams = {
        params: {
          action: 'aws-view-requests',
          Requestor_Id: id
        }
      }
      let requests = await ApiService.get(process.env.VUE_APP_AWS_ACCOUNT_ONBOARDING, reqParams)
      if (requests.data.length) {
        callback(requests.data)
      } else {
        callback(null, { error: 'No Records Found' })
      }
    } catch (error) {
      vm.$store.commit('loadingUserRequests', false)
    }
  },
  //UPDATE ONBOARDING WORKFLOW 
  updateExistingAcctId: async function (data, callback) {
    try {
      
      let reqData = {
        type: 'update-onboarding',
        action: 'onboardingheader',
        // ...data.data
        Acct_ID: data.accountId,
        Onboarding_Id: data.onboardingId,
        Acct_Exp_Id: data.data.Acct_Exp_Id,
        Financial_Id: data.data.Financial_Id,
        Unique_Agreement_Id:data.data.Unique_Agreement_Id,
        AcctSecurity_Id: data.data.AcctSecurity_Id,
        Onboarding_Status:data.data.Onboarding_Status
      }
      console.log('------- updateExistingAcctId -------')
      console.log(reqData)
      console.log('------------------------------------')
      let res =  await ApiService.put(process.env.VUE_APP_REQUEST_AWS_ACCOUNT, reqData)
      callback(res)

    } catch(error) {

    }
  },

    // Upload to s3
    uploadToS3: async function (file, type) {
      if (type === 'AWS_ONBOARDING') {
        let timestamp = Math.floor(Date.now() / 1000)
        file.filename = timestamp + '_' + file.filename.replace(/\s/g, '-')
      } else {
        file.filename = file.filename.replace(/\s/g, '-')
      }
      let object_key = file.filename
      let ContentType = file.FileType

    let request_params = {params: {
      name: object_key, method: 'put_object', contenttype: ContentType
    }}

    let getPresignedUrl = await ApiService.get(process.env.VUE_APP_GALAXY_UPLOAD, request_params);
    let presigned_url = getPresignedUrl.data;

    let uploadDetails = { Key: file.filename, ContentType: ContentType, file: file.File }
    let UploadResponse = await ApiService.put(presigned_url, uploadDetails);

    return UploadResponse
    // let get_url_params = { params: { name: file.filename }};
    // let s3_url = await ApiService.get(process.env.VUE_APP_GALAXY_UPLOAD, get_url_params);
    // console.log('s3URL', s3_url)
  },
  createAccount: async function (data, callback) {
    try {

      let res =  await ApiService.post(process.env.VUE_APP_CREATE_AWS_ACCOUNT, data)
      if(res.err) {
        callback(null , res.err.response.data.error)  
      } else {
        callback(res.data.id)
      }
    } catch (error) {
      callback(null, { err: 'Error Creating an Account'})
    }
  },
  downloadAllOnboardingRequests: async function (params, callback) {
    try {
      let reqParams = {
        params: {
          action: 'download'
        }
      }
      if (params) {
        reqParams.params.orderBy = params.sortBy || 'Onboarding_Id'
        reqParams.params.order = params.sortOrder || 'DESC'
        if (params.listStatus) {
          reqParams.params.listStatus = params.listStatus || ''
        }
        if (params.isTrainingAccount) {
          reqParams.params.isTrainingAccount = params.isTrainingAccount
        }
        if (params.search) {
          reqParams.params.search = params.search
        }
      }
      let requests = await ApiService.get(process.env.VUE_APP_AWS_ACCOUNT_ONBOARDING, reqParams)
      if (requests.data) {
        console.log('requests.data.length', requests.data)
        callback(requests.data)
      } else {
        console.log('no records found')
        callback(null, { error: 'No Records Found' })
      }
    } catch (error) {
      console.log('error: ' + error)
      vm.$store.commit('setDownloadingAccount', false)
    }
  },

}

export default awsAcctService
